export default {
    methods: {
        formatMoney(amount, longDisplay = false) {
            const options = {
                style: 'currency',
                currency: this.bundleData.currency
            }
            // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#options
            // See 'currencyDisplay' option
            if (!longDisplay) {
                options.currencyDisplay = 'narrowSymbol'
            }
            const formatter = new Intl.NumberFormat(undefined, options);
            
            const amountToFormat = isNaN(amount) ? 0 : amount
            return formatter.format(amountToFormat);
        }
    }
}
